// スカウトメールAI ブランドカラー・テーマ
export const THEME = {
  // Primary
  primary: "#2563EB", // blue-600
  primaryDark: "#1D4ED8", // blue-700
  primaryLight: "#DBEAFE", // blue-100

  // Accent
  accent: "#F97316", // orange-500
  accentLight: "#FFF7ED", // orange-50

  // Success / Error
  success: "#16A34A", // green-600
  successLight: "#DCFCE7", // green-100
  error: "#DC2626", // red-600
  errorLight: "#FEE2E2", // red-100
  warning: "#D97706", // amber-600
  warningLight: "#FEF3C7", // amber-100

  // Neutral
  bg: "#FFFFFF",
  bgSub: "#F8FAFC", // slate-50
  bgDark: "#0F172A", // slate-900
  text: "#0F172A", // slate-900
  textSub: "#64748B", // slate-500
  textLight: "#FFFFFF",
  border: "#E2E8F0", // slate-200

  // Gradient
  gradientStart: "#2563EB",
  gradientEnd: "#7C3AED", // violet-600
} as const;

// フレーム定数
export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

// シーン別フレーム数
export const SCENE_FRAMES = {
  opening: 3 * FPS, // 90 frames = 3s
  jobPosting: 12 * FPS, // 360 frames = 12s
  skillCheck: 18 * FPS, // 540 frames = 18s
  scoutMail: 18 * FPS, // 540 frames = 18s
  ending: 5 * FPS, // 150 frames = 5s
} as const;

// トランジション用フレーム
export const TRANSITION_FRAMES = 15;

// 合計フレーム（トランジション分を差し引き）
export const TOTAL_FRAMES =
  SCENE_FRAMES.opening +
  SCENE_FRAMES.jobPosting +
  SCENE_FRAMES.skillCheck +
  SCENE_FRAMES.scoutMail +
  SCENE_FRAMES.ending -
  TRANSITION_FRAMES * 4; // 4回のトランジション
